import { X } from "lucide-react";
import type * as React from "react";

import { strings } from "@/I18n";
import { cn } from "@/lib/utils";
import { Badge } from "@/v2/ui/primitives/badge";

export interface FilterChipTag {
  name: string;
  color: string;
}

export interface FilterChipProps {
  label: string;
  value: string;
  onRemove: () => void;
  className?: string;
  tags?: FilterChipTag[];
}

const FilterChip: React.FC<FilterChipProps> = ({
  label,
  value,
  onRemove,
  className,
  tags,
}) => {
  return (
    <Badge
      variant="secondary"
      className={cn("tw-gap-1 tw-pr-1 tw-pl-3 tw-py-1 tw-h-auto", className)}
    >
      <span className="tw-text-xs tw-flex tw-items-center tw-gap-1">
        <span className="tw-font-semibold">{label}:</span>
        {tags && tags.length > 0 ? (
          tags.map((tag, i) => (
            <span key={tag.name} className="tw-flex tw-items-center tw-gap-1">
              <span
                className="tw-w-2 tw-h-2 tw-rounded-full tw-flex-shrink-0"
                style={{ backgroundColor: tag.color }}
              />
              <span>
                {tag.name}
                {i < tags.length - 1 ? "," : ""}
              </span>
            </span>
          ))
        ) : (
          <span>{value}</span>
        )}
      </span>
      <button
        type="button"
        onClick={onRemove}
        className="tw-ml-1 tw-rounded-full tw-p-1.5 -tw-m-1 hover:tw-bg-background/80 tw-transition-colors"
      >
        <X className="tw-h-3 tw-w-3" />
        <span className="tw-sr-only">{strings("common.removeFilter")}</span>
      </button>
    </Badge>
  );
};

FilterChip.displayName = "FilterChip";

export { FilterChip };
